import * as React from "react";
const SvgDe = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 512 512", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#464655"
}, d: "M512,200.092H0V97.103c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828 V200.092z" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#FFE15A"
}, d: "M503.172,423.724H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.908h512v102.988 C512,419.772,508.047,423.724,503.172,423.724z" }), /* @__PURE__ */ React.createElement("rect", { y: 200.088, style: {
  fill: "#FF4B55"
}, width: 512, height: 111.812 }));
export default SvgDe;
